import React from 'react';
import style from './LoginIntuitEmailNotVerified.module.scss';

const LoginIntuitEmailNotVerified = () => (
  <p className={style.emailNotVerifiedText}>
    Your email is not verified. Please{' '}
    <a
      href="https://accounts.intuit.com/app/account-manager/security"
      target="_blank"
      rel="noopener noreferrer"
    >
      login to your QuickBooks Online account and verify your email address
    </a>
    .
  </p>
);

export default LoginIntuitEmailNotVerified;
